module.exports = __webpack_public_path__ + "static/media/doc.148bb9a7.png";